export const CELL_VALUE_TYPE_CONFIG = {
  NULL: 'Null',
  MERGE: 'Merge',
  NUMBER: 'Number',
  STRING: 'String',
  DATE: 'Date',
  HYPERLINK: 'Hyperlink',
  FORMULA: 'Formula',
  SHARED_STRING: 'Shared String',
  RICH_TEXT: 'Rich Text',
  BOOLEAN: 'boolean',
  ERROR: 'Error',
} as const;

export const CELL_IMPORT_STRATEGY_CONFIG = {
  COORDINATES: 'Coordinates',
  NAMED_CELL: 'Named Cell',
  TABLE_STRUCTURE: 'Table Structure',
} as const;

export const CONDITIONAL_FORMATTING_TYPE_CONFIG = {
  EXPRESSION: 'expression',
  CONTAINS_TEXT: 'containsText',
} as const;

export const CELL_STYLE_FILL_TYPE_CONFIG = {
  PATTERN: 'pattern',
} as const;

export const CELL_STYLE_FILL_PATTERN_CONFIG = {
  SOLID: 'solid',
} as const;

export const SHEET_STATE_CONFIG = {
  VISIBLE: 'visible',
  HIDDEN: 'hidden',
} as const;

export const FULL_SHEET_PROTECTION_CONFIG = {
  objects: true,
  scenarios: true,
  selectLockedCells: false,
  selectUnlockedCells: true,
  formatCells: false,
  formatColumns: false,
  formatRows: false,
  insertColumns: false,
  insertRows: false,
  insertHyperlinks: false,
  deleteColumns: false,
  deleteRows: false,
  sort: false,
  autoFilter: false,
  pivotTables: false,
};

export const WORKBOOK_IMPORT_STRATEGY_CONFIG = {
  SERVER: 'Server',
  CLIENT: 'Client',
} as const;

export const COMMON_EXCEL_WORKBOOK_CONFIG = {
  company: 'Aksia LLC',
  creator: 'help@aksia.com',
  keywords: 'Aksia, Export, Import',
  created: new Date('9/18/2025'),
} as const;
